import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  nome: string;
  email: string;
  role?: string;
  matricula?: string;
}

interface AuthState {
  token: string | null;
  user: User | null;
  tipo: 'cliente' | 'admin' | null;
  isAuthenticated: boolean;
  
  // Para compatibilidade com código existente
  setAuth: (userOrData: User | { token: string; user: User; tipo: 'cliente' | 'admin' }, token?: string) => void;
  clearAuth: () => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      tipo: null,
      isAuthenticated: false,

      setAuth: (userOrData, token?) => {
        // Se for objeto completo (novo formato)
        if (typeof userOrData === 'object' && 'token' in userOrData && 'tipo' in userOrData) {
          set({
            token: userOrData.token,
            user: userOrData.user,
            tipo: userOrData.tipo,
            isAuthenticated: true,
          });
        } 
        // Se for formato antigo (user, token)
        else if (token && typeof userOrData === 'object') {
          set({
            token,
            user: userOrData as User,
            tipo: 'admin',
            isAuthenticated: true,
          });
        }
      },

      clearAuth: () => {
        set({
          token: null,
          user: null,
          tipo: null,
          isAuthenticated: false,
        });
      },

      logout: () => {
        set({
          token: null,
          user: null,
          tipo: null,
          isAuthenticated: false,
        });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);

export default useAuthStore;
